// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
// Module
exports.push([module.id, ".title[data-v-0e7beaa2]{font-size:1.3rem;font-weight:bold;margin-bottom:1rem}.select[data-v-0e7beaa2]{position:relative}.select__body[data-v-0e7beaa2]{width:100%;height:3.2rem;color:#4D4D4D;font-size:1.3rem;border:0.1rem solid #D9D9D9;border-radius:.4rem;padding:.4rem 1rem;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;top:0;bottom:0;left:0;right:0}.select__body[data-v-0e7beaa2]::-ms-expand{color:#4D4D4D;background:#fff;border:none}\n", ""]);
// Exports
module.exports = exports;
